import * as React from 'react';
import { FC } from 'react';

import { MarketingTileSkeleton } from 'components/marketing-tile/marketing-tile.skeleton';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { Features } from '../features';

import { Spacer } from './styles';
import { IHomePageViewProps } from './types';

export const HomePageView: FC<IHomePageViewProps> = ({ isLoading, featureHomePage }) => {
  const hasBottomServiceMode = useFlag(LaunchDarklyFlag.ENABLE_BOTTOM_SERVICE_MODE);
  const showLoyaltyBannerV2inHome = useFlag(LaunchDarklyFlag.SHOW_LOYALTY_BANNER_V2_IN_HOME);

  if (isLoading) {
    return <MarketingTileSkeleton />;
  }

  if (featureHomePage?.components) {
    const firstItemIsMainHero = featureHomePage?.components[0]?.__typename === 'MainHero';
    const loyaltyBannerAndHero =
      featureHomePage?.components[0]?.__typename === 'Hero' && showLoyaltyBannerV2inHome;
    return (
      <>
        {loyaltyBannerAndHero || firstItemIsMainHero ? null : (
          <Spacer $isSmall={hasBottomServiceMode || !showLoyaltyBannerV2inHome} />
        )}
        <Features components={featureHomePage.components} location="HomePage" />
      </>
    );
  }
  return null;
};
